// biome-ignore lint/style/useNodejsImportProtocol: <explanation>
import process from 'process'
// from: https://stackoverflow.com/questions/72238175/why-useeffect-running-twice-and-how-to-handle-it-well-in-react
import { type DependencyList, type EffectCallback, useEffect, useRef } from 'react'

const isDev = (): boolean => {
  return !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
}

console.log('Mode: ', isDev())

/**
 * Wraps React.useEffect to only run the effect after the component has mounted.
 * Especially useful for avoiding the double invocation of useEffect on the initial render when running in StrictMode.
 * @see https://react.dev/blog/2022/03/08/react-18-upgrade-guide#updates-to-strict-mode
 * @param effect
 * @param deps
 */
const useEffectAfterMountInDev = (
  effect: EffectCallback,
  deps?: DependencyList
) => {
  const mounted = useRef(false)

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (mounted.current) {
      return effect()
    }
    mounted.current = true
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}

export const useEffectAfterMount: typeof useEffect = isDev()
  ? useEffectAfterMountInDev
  : useEffect
